/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect } from 'react';
import { DeepMap, FieldError } from 'react-hook-form';
import {
    trackFullNameError,
    trackEmailError,
    trackPhoneError,
    trackPostcodeError,
    trackSituationError
} from '../EmailAgentForm.tracking';
import { EmailAgentSubmissionProps } from '../EmailAgentForm.types';

const useAgentFormErrorTracking = (
    errors: DeepMap<EmailAgentSubmissionProps, FieldError>
) => {
    const [nameErrorDisplayed, setNameErrorDisplayed] = useState<boolean>(
        false
    );
    const [emailErrorDisplayed, setEmailErrorDisplayed] = useState<boolean>(
        false
    );
    const [phoneErrorDisplayed, setPhoneErrorDisplayed] = useState<boolean>(
        false
    );
    const [
        postcodeErrorDisplayed,
        setPostcodeErrorDisplayed
    ] = useState<boolean>(false);
    const [
        situationErrorDisplayed,
        setSituationErrorDisplayed
    ] = useState<boolean>(false);

    if (errors.name && errors.name.type !== 'required') {
        if (!nameErrorDisplayed) {
            setNameErrorDisplayed(true);
        }
    } else if (nameErrorDisplayed) {
        setNameErrorDisplayed(false);
    }

    useEffect(() => {
        if (errors.name) {
            trackFullNameError(errors.name.message);
        }
    }, [nameErrorDisplayed]);

    if (errors.email && errors.email.type !== 'required') {
        if (!emailErrorDisplayed) {
            setEmailErrorDisplayed(true);
        }
    } else if (emailErrorDisplayed) {
        setEmailErrorDisplayed(false);
    }

    useEffect(() => {
        if (errors.email) {
            trackEmailError(errors.email.message);
        }
    }, [emailErrorDisplayed]);

    if (errors.phone && errors.phone.type !== 'required') {
        if (!phoneErrorDisplayed) {
            setPhoneErrorDisplayed(true);
        }
    } else if (phoneErrorDisplayed) {
        setPhoneErrorDisplayed(false);
    }

    useEffect(() => {
        if (errors.phone) {
            trackPhoneError(errors.phone.message);
        }
    }, [phoneErrorDisplayed]);

    if (errors.postcode && errors.postcode.type !== 'required') {
        if (!postcodeErrorDisplayed) {
            setPostcodeErrorDisplayed(true);
        }
    } else if (postcodeErrorDisplayed) {
        setPostcodeErrorDisplayed(false);
    }

    useEffect(() => {
        if (errors.postcode) {
            trackPostcodeError(errors.postcode.message);
        }
    }, [postcodeErrorDisplayed]);

    if (
        errors.senderPropertyStatus &&
        errors.senderPropertyStatus.type !== 'required'
    ) {
        if (!situationErrorDisplayed) {
            setSituationErrorDisplayed(true);
        }
    } else if (situationErrorDisplayed) {
        setSituationErrorDisplayed(false);
    }

    useEffect(() => {
        if (errors.senderPropertyStatus) {
            trackSituationError(errors.senderPropertyStatus.message);
        }
    }, [situationErrorDisplayed]);
};

export default useAgentFormErrorTracking;
